<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #type="params">
        <span v-if="params.params.type == 1">普通订单</span>
        <span v-if="params.params.type == 2">合同订单</span>
        <!-- <span v-else>合同订单</span> -->
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "MakeupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'recycle',
      breadcrumb: [
        { name: "订单管理" },
        { name: "订单回收站" },
      ],
      formCtrl: [
        {
          label: "订单类型",
          keyName: "type",
          placeholder: "请选择订单类型",
          type: "select",
          options: [
            { label: '全部', value: null },
            { label: '普通订单', value: 1 },
            { label: '合同订单', value: 2 },
          ],
        },
        {
          label: "订单状态",
          keyName: "isstatus",
          placeholder: "请选择订单状态",
          type: "select",
          options: [
            { label: '全部', value: null },
            { label: '未完成', value: 1 },
            { label: '已完成', value: 2 },
          ],
        },
        { ...this.ctrls.fleet, options: [] },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { label: "装货日期", keyName: "starttime", },
        { label: "卸货日期", keyName: "edittime", },
      ],
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '订单号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      cols: [
        { prop: "order_num", label: "订单号", minwidth: 120 },
        // { prop: "type", label: "订单类型", slot: 'type' },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "del_name", label: "删除人", width: 120 },
        { prop: "del_desc", label: "删除原因", width: 120 },
        { prop: "del_time", label: "删除时间", width: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recycleview?id=${id}&mode=view`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recyclefee?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {
    setFleet({ team }) {
      // console.log('team', team)
      // console.log('formCtrl', this.formCtrl)
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet' && team) {
          this.setCtrlOption(c, team, 'nickname')
        }
      })
      this.$forceUpdate()
    },
  },
  mounted() {
    this.getFleet()
  },
};
</script>

<style lang="less" scoped></style>
